import React, {useState, useEffect} from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPIFunnelSet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localAcceptedFilterModel, setLocalAcceptedFilterModel] = useState();
    const { getComparableTimeframe } = useDates();

    useEffect(() => {
        if (!filterModel) return;
        const localAcceptedFilterModel = { items:[...filterModel.items, {field:"status", operator:"equals", value:"accepted"}]}
        setLocalAcceptedFilterModel(localAcceptedFilterModel);
        setLocalDrawable(true);
    },[filterModel])

    return (localDrawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Leads"
                dataProviderName={'statisticsviews/item/count/opportunities/lead'}
                filters={filterModel}
                compareFilters={
                    {
                        ...getComparableTimeframe(filterModel, 'registered_at'),
                        timeline: {
                            collection: 'views_opportunities_lead',
                            field: 'registered_at',
                            granularity: 'month'
                        }
                    }
                }
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Proposte"
                dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                filters={filterModel}
                compareFilters={
                    {
                        ...getComparableTimeframe(filterModel, 'registered_at'),
                        timeline: {
                            collection: 'views_opportunities_proposal',
                            field: 'registered_at',
                            granularity: 'month'
                        }
                    }
                }
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Accettate"
                dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                filters={localAcceptedFilterModel}
                compareFilters={
                    {
                        ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                        timeline: {
                            collection: 'views_opportunities_proposal',
                            field: 'registered_at',
                            granularity: 'month'
                        }
                    }
                }
                comparePositiveCondition={'straight'}
            />
        </Box>
    )
}

export default KPIFunnelSet;